import { API_URL } from '../config';
import {API_ENDPOINTS} from "../constants";
import {postDataWithSession} from "./index";

export const getDistricts = (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_DISTRICTS}`, {}, true);
}

export const saveNewDistrict = (name,externalId,queryParams) => {
  const options = {
    body: JSON.stringify({
        name: name,
        externalId: externalId
    })
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.ADD_DISTRICT}`, options);
}

export const updateDistrict = (district,queryParams) => {
  const options = {
    body: JSON.stringify(district)
  }

  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.UPDATE_DISTRICT}`, options);
}

export const storeCurrentDistrictInLocalStorage = (currentDistrict) => {
  localStorage.setItem('currentDistrict', JSON.stringify(currentDistrict));
};

export const getCurrentDistrictFromLocalStorage = () => {
  const currentDistrict = localStorage.getItem('currentDistrict');
  return (currentDistrict !== 'undefined') ? JSON.parse(currentDistrict) : currentDistrict;
};